module.exports = __webpack_public_path__ + "img/map8_empty.8a166d7d.png";